export const adjustBase = (href, basePath = '') => href.replace(basePath, '') || '/';
//# sourceMappingURL=adjustBase.js.map